export default "__VITE_ASSET__93a63231__"